import MinisiteInfoBoxes, { type InfoBox } from "./InfoBoxes";

interface Props {
  content?: string;
  hotelName?: string;
  estimateId?: number;
  estimateDate?: string;
  boxes?: InfoBox[];
}

export default function MinisiteSidebar({
  content,
  hotelName,
  estimateId,
  estimateDate,
  boxes,
}: Props) {
  if (!content && !hotelName && !estimateId && (!boxes || boxes.length === 0))
    return null;

  return (
    <aside className="min-h-[420px] xl:min-h-[1180px] bg-card/50 rounded-[1.5rem] p-6 flex flex-col gap-6">
      {estimateId && (
        <div className="rounded-lg border bg-card px-4 py-3 text-sm">
          <p className="font-medium text-card-foreground">
            Preventivo N. {estimateId}
          </p>
          {estimateDate && (
            <p className="text-xs text-muted-foreground mt-0.5">
              del {new Date(estimateDate).toLocaleDateString("it-IT")}
            </p>
          )}
        </div>
      )}
      {content ? (
        <div
          className="w-full prose prose-sm max-w-none overflow-hidden break-words text-foreground"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      ) : (
        hotelName && (
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold text-sm">
              {hotelName.charAt(0)}
            </div>
            <div>
              <p className="font-semibold text-sm">Ufficio Prenotazioni</p>
              <p className="text-xs text-muted-foreground">{hotelName}</p>
            </div>
          </div>
        )
      )}

      {boxes && boxes.length > 0 && (
        <div className="pt-2 flex flex-col gap-3">
          <MinisiteInfoBoxes boxes={boxes} />
        </div>
      )}
    </aside>
  );
}
